<template>
  <p v-if="isDisplay(errors, anotherCondition)" class="error error-list">
    <span class="d-lib">{{ errorItemsString }}が</span>
    <span class="d-lib">正しく入力できていません</span>
  </p>
</template>

<script setup>
import { computed } from 'vue';
import { useErrorMessage } from '@component_path/inquiry_form_common_module/custom_hook/ErrorMessage.js';
import { useFormErrors } from 'vee-validate';
import { isEmpty } from 'lodash';

const props = defineProps({
  formFields: {
    type: Object,
    required: true
  },
  anotherCondition: {
    type: Boolean,
    required: false,
    default: true
  }
});

const errors = useFormErrors();
const { isDisplay } = useErrorMessage();
const errorItemsString = computed(() => {
  return Object.keys(errors.value)
    .map(field => props.formFields[field])
    .filter(field => !isEmpty(field))
    .join('、');
});
</script>
